import Model from 'flarum/common/Model';
 
export default class GroupApplication extends Model {
    apiEndpoint() {
        return '/mircle-group-applications';
    }
} 